import React from "react";

export default function Table(props) {
    return (
        <div className="flex flex-col">
            <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    <div className="overflow-hidden border-b border-gray-200 shadow sm:rounded-lg">
                        <table className="min-w-full max-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50 ">
                                <tr>{props.columns}</tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 bg-white">
                                {props.children}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
